export default "__VITE_ASSET__D6zC5EjW__"